import images from "../../../Utils/Images";

const teamData = [
  {
    id: 1,
    name: "Haroon Riaz",
    role: "CEO",
    image: images.haroon,
    description:
      "Haroon leads the company with a clear vision and strategic mindset. As CEO, he focuses on business growth, innovation, and building strong client relationships while guiding the team toward long-term success.",
    social: "http://www.linkedin.com/in/haroonriaz15",
  },
  {
    id: 2,
    name: "Raza Khan",
    role: "Frontend Engineer and Co Founder",
    image: images.raza,
    description:
      "Raza is a Co-Founder and Frontend Engineer who specializes in building modern, responsive user interfaces. He plays a key role in product architecture, UI performance, and maintaining high code quality across projects.",
    social: "https://www.linkedin.com/in/raza-khan-432443237/",
  },
  {
    id: 3,
    name: "Adeel Saleem",
    role: "Manager and Co Founder",
    image: images.adeel,
    description:
      "Adeel is a Co-Founder and Manager responsible for overseeing operations and team coordination. He ensures projects are delivered on time while maintaining smooth communication between clients and internal teams.",
    social: "http://www.linkedin.com/in/adeel--saleem",
  },
];

export default teamData;
